<div class="dvb-draggable-dropzone dropzone row">
    <i class="on-dashed-line fa" ng-class="vm.icon" uib-tooltip="{{vm.labelTooltip | translate}}" tooltip-placement="right-center"></i>
    <div class="col-xs-12">
        <ng-transclude></ng-transclude>
    </div>
</div>
